import { render } from "./Hero.vue?vue&type=template&id=3a554692"
import script from "./Hero.vue?vue&type=script&lang=ts"
export * from "./Hero.vue?vue&type=script&lang=ts"
script.render = render

export default script